import * as React from 'react';
import { useState, useEffect } from 'react';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import {
  Card,
  Table,
  Stack,
  Box,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Modal,
  CircularProgress,
  Pagination,
  Avatar,
  TableHead,
  TextField,
  MenuItem,
  Divider,
  Rating,
  Grid,
  Tooltip
} from '@mui/material';
import Label from 'src/components/Label';
import { LoadingButton } from '@mui/lab';
import pallete from '../theme/palette';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead } from '../sections/@dashboard/user';
import { api } from '../Api';
import OrderDetailModal from 'src/sections/@dashboard/orders/OrderDetailModal';
import ChangeOrderStatus from 'src/sections/@dashboard/orders/ChangeOrderStatus';
import { Link as RouterLink } from 'react-router-dom';
import TimeLineModal from 'src/sections/@dashboard/TimelineModal/TimeLineModal';

export default function Orders() {
  const TABLE_HEAD = [
    { id: 'user', label: 'User', alignRight: false },
    { id: 'order_no', label: 'Order No', alignRight: false },
    { id: 'order_no', label: 'No of Items', alignRight: false },
    { id: 'amount', label: 'Amount (LKR)', alignRight: false },
    { id: 'time', label: 'Order Date', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: 'action', label: 'Action', alignRight: false }
  ];

  const [permission, setpermission] = useState([]);
  const requirement = ['visible', 'timeline', 'details'];

  function checkRender() {
    let check = 'orders';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check
    );
    localPerm[0].permission_types.filter((items) =>
      requirement.includes(items.permission_type_name.toLowerCase())
        ? setpermission((permissions) => [...permissions, items.permission_type_name.toLowerCase()])
        : false
    );
  }

  useEffect(() => {
    checkRender();
  }, []);

  const [list, setlist] = useState([]);
  const [detail, setDetail] = React.useState(false);
  const [loading, setloading] = useState(true);
  const [sorting, setsorting] = useState('');
  const [timelinemodal, settimelinemodal] = useState(false);
  const [sortinglist, setsortinglist] = useState([
    { id: 1, name: 'Date Placed (Newest First)', value: 'date_newest_first' },
    { id: 2, name: 'Date Placed (Oldest First)', value: 'date_oldest_first' },
    { id: 3, name: 'No. of Items (Ascending)', value: 'asc' },
    { id: 4, name: 'No. of Items (Descending)', value: 'desc' }
  ]);

  const [status, setStatus] = useState('');
  const [statuslist, setstatuslist] = useState([
    { id: 1, name: 'All' },
    { id: 2, name: 'Placed' },
    { id: 3, name: 'Shipped' },
    { id: 4, name: 'Delivered' },
    { id: 5, name: 'Completed' },
    { id: 6, name: 'Refunded' },
    { id: 7, name: 'Cancelled' }
  ]);

  const detailClose = () => {
    setDetail(false);
  };

  useEffect(() => {
    if (sorting == '') {
      setsorting(sortinglist[0]);
    }
  }, [sorting]);

  function getOrders(pagenumber, sort, status) {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    // Build the query parameters
    const params = new URLSearchParams();
    pagenumber && params.append('page', pagenumber);
    search.length > 0 && params.append('search', search);
    sort && params.append('orderBy', sort.value);
    status && status.name != 'All' && params.append('status', status.name);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    const url = `${api.get_orders}?${params.toString()}`;
    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch orderss');
        }
      })
      .then((result) => {
        setlist(result.data);
        result?.count ? setpagesCount(Math.ceil(result?.count / 20)) : setpagesCount(1);
      })
      .catch((error) => {
        setlist([]);
        setpagesCount(0);
        console.log('error', error);
      })
      .finally(() => {
        setsearchLoading(false);
        setloading(false);
      });
  }

  useEffect(() => {
    setloading(true);
    getOrders();
  }, []);

  const [orders, setorders] = useState(null);
  const [timelinelist, settimelinelist] = useState('');

  const [search, setsearch] = useState('');
  const [searchLoading, setsearchLoading] = useState(false);
  const tableRef = React.createRef();
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = React.useState(1);

  const handlePageChange = (event, value) => {
    list.length = 0;
    setloading(true);
    setPage(value);
    getOrders(value, sorting, status);
  };

  const [statusModal, setstatusModal] = useState(false);

  function openStatusModal(row) {
    setorders(row);
    setstatusModal(true);
  }

  function opentimelineModal(row) {
    settimelinelist(row);
    settimelinemodal(true);
  }
  const refreshAdmin = () => {
    setstatusModal(false);
    getOrders(page, sorting, status);
  };

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getOrders(1, sorting, status);
    }
  }, [search]);

  const isDataFound = list.length === 0;

  const style = {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };

  const boxStyle = {
    maxWidth: '70%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    border: '2px solid',
    borderColor: pallete.primary.main
  };

  // State for product details modal
  const [productDetails, setProductDetails] = useState(null);
  const [productDetailsOpen, setProductDetailsOpen] = useState(false);

  const handleProductClick = (product) => {
    setProductDetails(product);
    setDetail(true);
  };

  const handleProductDetailsClose = () => {
    setProductDetailsOpen(false);
    setProductDetails(null);
  };

  const handlesorting = (event) => {
    const newsort = event.target.value;
    list.length = 0;
    setloading(true);
    setsorting(newsort);
    setPage(1);
    getOrders(1, newsort, status);
  };

  const handlestatusChange = (event) => {
    const newstatus = event.target.value;
    list.length = 0;
    setStatus(newstatus);
    setsorting('');
    setloading(true);
    setPage(1);
    getOrders(1, sorting, newstatus);
  };

  const ProductTable = ({ productDetails }) => (
    <Box>
      <Typography variant="h5" textAlign={'center'}>
        Details
      </Typography>
      <Stack>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Order NO:{' '}
          </Typography>
          <Typography variant="body2" ml={1}>
            {productDetails?.order_no || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Shipping Address:{' '}
          </Typography>
          <Typography variant="body2" ml={1}>
            {productDetails?.shipping_address?.location || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Billing Address:{' '}
          </Typography>

          <Typography variant="body2" ml={1}>
            {productDetails?.delivery_address?.location || ' N/A'}
          </Typography>
        </Box>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body2" fontWeight={'bold'}>
            Status:
          </Typography>
          <Label
            style={{ height: 30, paddingLeft: 30, paddingRight: 30, width: 100, marginLeft: 10 }}
            variant="ghost"
            color={getStatusColor(productDetails?.status)}
          >
            <Typography variant="body2" style={{ textTransform: 'capitalize' }}>
              {productDetails?.status}
            </Typography>
          </Label>
        </Box>
      </Stack>

      <Card style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={'bold'}>
                  Name
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Unit Price (LKR)
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Quantity
                </Typography>
              </TableCell>

              <TableCell>
                <Typography variant="body2 " fontWeight={'bold'}>
                  Sub Total
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productDetails?.order_details?.map((item) => (
              <>
                {console.log('item of orders', productDetails)}
                <TableRow key={item.code}>
                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Avatar
                        alt={item?.name}
                        src={item?.product?.media?.uri}
                        style={{ width: 40, height: 40, borderRadius: 20 }}
                      />
                      <div className="one-line-ellipsis">
                        <Typography variant="body2" color="black">
                          {item?.product?.name || 'N/A'}
                        </Typography>
                        <Typography variant="caption" color="black">
                          {item?.product?.code || 'N/A'}
                        </Typography>
                      </div>
                    </Stack>
                  </TableCell>

                  <TableCell>
                    <Typography variant="caption">
                      {item?.product?.price ? item?.product?.price : 'N/A'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">{item?.product?.quantity || 'N/A'}</Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography variant="caption">{item?.discount || 'N/A'}</Typography>
                  </TableCell> */}
                  <TableCell>
                    <Typography variant="caption">{item?.product?.total || 'N/A'}</Typography>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </Card>
      {productDetails?.discount && (
        <>
          <Typography mt={2} style={{ flex: 1 }} variant="h5" component="div">
            Discounts:
          </Typography>
          <Stack justifyContent="space-between" spacing={2}>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Name:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.name}</Typography>
            </Box>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Coupon:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.coupon_code}</Typography>
            </Box>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Type:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.type}</Typography>
            </Box>
            <Box
              py={0}
              width="40%"
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
            >
              <Typography style={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}>
                Value:{' '}
              </Typography>
              <Typography>{productDetails?.discount?.value}</Typography>
            </Box>
          </Stack>
        </>
      )}

      <Stack direction="row" justifyContent="space-between" mb={1} spacing={2}>
        <Stack justifyContent="left" style={{ marginTop: ' 5%' }}>
          <Box
            py={0}
            width="40%"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box>
                <Avatar
                  alt={productDetails?.user?.name}
                  src={productDetails?.user?.avatar}
                  sx={{ width: 56, height: 56 }}
                />
              </Box>
              <Box>
                <div className="one-line-ellipsis" style={{ fontSize: 20 }}>
                  {productDetails?.user?.name || 'N/A'}
                </div>
                <div className="one-line-ellipsis" style={{ fontSize: 14 }}>
                  {productDetails?.user?.email || 'N/A'}
                </div>
              </Box>
            </Stack>
          </Box>
          <Divider variant="fullWidth" style={{ marginTop: 10, width: 350 }} />

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              flex: 1,
              marginTop: 10
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h5" component="div">
              OverAll Order Rating:
            </Typography>
            <Rating size="large" name="simple-controlled" disabled />
          </Box>
          <Divider style={{ width: 350 }} />

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h6" component="div">
              OverAll Buyer Rating:
            </Typography>
            <Rating size="large" name="simple-controlled" disabled />
          </Box>
          <Stack style={{ width: 250 }}>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Product Rating:{' '}
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Delivery Rating:{' '}
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Communication:
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
            <Box
              py={0}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                marginTop: 5
              }}
              className="column"
            >
              <Typography style={{ flex: 1 }} component="div">
                Sending Time:{' '}
              </Typography>
              <Rating name="simple-controlled" disabled />
            </Box>
          </Stack>

          <Divider aria-hidden="true" style={{ marginTop: 10, width: 350 }} />
          <Box
            py={0}
            style={{
              flexDirection: 'row',
              marginTop: 5,
              flex: 1
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} variant="h6" component="div">
              Vintit Rating
            </Typography>
            <Box>
              <Rating size="large" name="simple-controlled" disabled />
            </Box>
          </Box>

          <Box
            py={0}
            style={{
              flexDirection: 'row',
              marginTop: 5,
              flex: 1,
              width: 600
            }}
          >
            <Typography
              row
              sx={{ textAlign: 'justify', marginRight: 3 }}
              variant="h5"
              component="div"
            >
              Review
            </Typography>

            <Typography row>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>
        </Stack>

        <Stack justifyContent="right" style={{ alignItems: 'flex-end', marginTop: ' 5%' }}>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              marginTop: 5,
              width: 250
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Order Total:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum ? productDetails?.over_all_sum?.products_price : 'N/A'}
            </Typography>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Buyer Protection Fee:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.buyer_protection_fee !== undefined &&
              productDetails?.over_all_sum?.buyer_protection_fee !== null
                ? productDetails?.over_all_sum?.buyer_protection_fee
                : 'N/A'}
            </Typography>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Delivery Fee:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.delivery_fee !== undefined &&
              productDetails?.over_all_sum?.delivery_fee !== null
                ? productDetails?.over_all_sum?.delivery_fee
                : 'N/A'}
            </Typography>
          </Box>
          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 5
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Discount:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.discount !== undefined &&
              productDetails?.over_all_sum?.discount !== null
                ? productDetails?.over_all_sum?.discount
                : 'N/A'}
            </Typography>
          </Box>

          <Box
            py={0}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: 250,
              marginTop: 20
            }}
            className="column"
          >
            <Typography style={{ flex: 1 }} component="div">
              Total:
            </Typography>
            <Typography row sx={{ textAlign: 'justify', marginRight: 3 }} component="div">
              {productDetails?.over_all_sum?.total !== undefined &&
              productDetails?.over_all_sum?.total !== null
                ? productDetails?.over_all_sum?.total
                : 'N/A'}
            </Typography>
          </Box>
        </Stack>
      </Stack>

      <Box
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: 30
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={handleProductDetailsClose}
          size={'small'}
        >
          Close
        </Button>
      </Box>
    </Box>
  );

  const getStatusColor = (status) => {
    console.log(status);
    switch (status.toLowerCase()) {
      case 'placed':
        return 'secondary';
      case 'shipped':
        return 'info';
      case 'delivered':
        return 'success';
      case 'completed':
        return 'success';
      case 'refunded':
        return 'warning';
      case 'cancelled':
        return 'error';
      default:
        return 'primary';
    }
  };

  return (
    <Page title={`Orders | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        {/* Product Details Modal */}
        {/* <Modal open={productDetailsOpen} onClose={handleProductDetailsClose} style={style}>
          <Box sx={boxStyle} px={5} pt={2} pb={5} style={{ backgroundColor: '#fafafb' }}>
            <ProductTable productDetails={productDetails} />
          </Box>
        </Modal> */}

        {/* orders DETAIL MODAL */}
        <Modal style={style} open={detail} onClose={detailClose}>
          <Box
            sx={boxStyle}
            px={5}
            pt={2}
            pb={5}
            style={{ backgroundColor: '#fafafb', overflowX: 'hidden' }}
          >
            <OrderDetailModal handleClose={detailClose} productDetails={productDetails} />
          </Box>
        </Modal>
        {/* CHANGE STATUS MODAL */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={statusModal}
          onClose={() => {
            setstatusModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              maxWidth: '40%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              border: '2px solid',
              borderColor: pallete.primary.main
            }}
            className="admin_modal_pa"
          >
            <ChangeOrderStatus
              property={orders}
              handleClose={() => {
                setstatusModal(false);
              }}
              refreshAdmin={refreshAdmin}
            />
          </Box>
        </Modal>
        {/* timeline */}
        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={timelinemodal}
          onClose={() => {
            settimelinemodal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              maxWidth: '40%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              border: '2px solid',
              borderColor: pallete.primary.main
            }}
            className="admin_modal_pa"
          >
            <TimeLineModal
              timelinelist={timelinelist}
              handleClose={() => settimelinemodal(false)}
            />
          </Box>
        </Modal>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Orders
          </Typography>
        </Stack>

        <Card>
          <Box
            p={2}
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between'
            }}
            className="top_options"
          >
            <Searchbar
              width={'90%'}
              value={search}
              setFunction={(val) => {
                setsearch(val);
              }}
              placeholder="Search"
              onClickSearch={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getOrders(1, sorting, status);
              }}
              onEnter={() => {
                setsearchLoading(true);
                setPage(1);
                list.length = 0;
                getOrders(1, sorting, status);
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2.5%' }}
              loading={searchLoading}
              variant="contained"
              onClick={() => {
                setsearchLoading(true);
                list.length = 0;
                setPage(1);
                getOrders(1, sorting, status);
              }}
              className="width_full"
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>

            <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={status}
              label={'Status'}
              onChange={handlestatusChange}
              className="width_full_status"
            >
              {statuslist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              style={{
                width: '40%',
                marginLeft: '2.5%'
              }}
              select
              value={sorting}
              label={'Sort by'}
              onChange={handlesorting}
              className="width_full_status"
            >
              {sortinglist.map((option) => (
                <MenuItem key={option.id} value={option}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <TableContainer sx={{ minWidth: 800 }}>
            <Scrollbar>
              <Table ref={tableRef}>
                <UserListHead headLabel={TABLE_HEAD} rowCount={TABLE_HEAD.length} />
                <TableBody>
                  {list.map((row) => {
                    console.log('order screen', row);
                    const {
                      id,
                      user,
                      product,
                      order_no,
                      published_at,
                      amount,
                      status,
                      order_details,
                      over_all_sum
                    } = row;
                    return (
                      <TableRow key={id}>
                        <TableCell scope="row" padding="normal" style={{ width: 170 }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Box>
                              <Avatar alt={user?.name} src={user && user?.avatar} />
                            </Box>
                            <Box>
                              <div className="one-line-ellipsis">{user?.name}</div>
                              <div className="one-line-ellipsis">
                                {(user && user.email) || 'N/A'}
                              </div>
                              <div>{(user && user.contact_no) || 'N/A'}</div>
                            </Box>
                          </Stack>
                        </TableCell>
                        {/* ORDER NO */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {order_no || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* NUMBER OF ITEMS */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {order_details?.length || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* AMOUNT */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {over_all_sum.total ? over_all_sum.total : 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* PUBLISHED_AT */}
                        <TableCell align="left">
                          <Typography fontSize={12} variant="subtitle2">
                            {published_at || 'N/A'}
                          </Typography>
                        </TableCell>
                        {/* STATUS */}
                        <TableCell align="left" style={{ maxWidth: 150 }}>
                          {status ? (
                            <Label
                              style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                              variant="ghost"
                              color={getStatusColor(status)}
                            >
                              <Typography
                                style={{
                                  textTransform: 'capitalize',
                                  fontWeight: 'bold',
                                  fontSize: 12
                                }}
                              >
                                {status}
                              </Typography>
                            </Label>
                          ) : (
                            <Typography
                              style={{
                                textTransform: 'capitalize',
                                fontWeight: 'bold',
                                fontSize: 12
                              }}
                            >
                              N/A
                            </Typography>
                          )}
                        </TableCell>
                        {/* ACTIONS */}
                        <TableCell style={{ position: 'relative', minHeight: 400 }}>
                          <Box
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start'
                            }}
                          >
                            {permission.includes('details') && (
                              // <Button
                              //   startIcon={<Iconify color={pallete.primary.main} icon="gg:notes" />}
                              //   onClick={(event) => {
                              //     event.preventDefault();
                              //     event.stopPropagation();
                              //     handleProductClick(row);
                              //   }}
                              //   variant="outlined"
                              //   size="small"
                              //   color="primary"
                              //   component={RouterLink}
                              //   to="#"
                              //   style={{
                              //     justifyContent: 'flex-start',
                              //     marginTop: 5,
                              //     width: 135
                              //   }}
                              // >
                              //   Details
                              // </Button>
                              <Tooltip title="Details">
                                <LoadingButton
                                  size="small"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    handleProductClick(row);
                                  }}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  component={RouterLink}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 18 }}
                                    icon="gg:notes"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                            {permission.includes('timeline') && (
                              // <Button
                              //   size="small"
                              //   onClick={() => opentimelineModal(row)}
                              //   style={{
                              //     justifyContent: 'flex-start',
                              //     marginTop: 5,
                              //     width: 135
                              //   }}
                              //   variant="outlined"
                              //   component={RouterLink}
                              //   to="#"
                              //   startIcon={
                              //     <Iconify
                              //       color={pallete.primary.main}
                              //       icon="mdi:swap-horizontal-bold"
                              //     />
                              //   }
                              // >
                              //   timeline
                              // </Button>

                              <Tooltip title="Timeline">
                                <LoadingButton
                                  size="small"
                                  onClick={() => opentimelineModal(row)}
                                  style={{
                                    justifyContent: 'center',
                                    width: 30, // Less than 30
                                    height: 30, // Ensuring it's a square button
                                    minWidth: 30, // Ensuring minimum width is set to 30
                                    padding: 0, // Removing padding to fit the icon properly
                                    lineHeight: 1, // Ensuring the icon is centered
                                    alignSelf: 'center',
                                    marginLeft: 1
                                  }}
                                  component={RouterLink}
                                  to="#"
                                >
                                  <Iconify
                                    style={{ cursor: 'pointer', fontSize: 20 }}
                                    icon="mdi:swap-horizontal-bold"
                                  />
                                </LoadingButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isDataFound && !loading && !searchLoading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
              {loading && (
                <Box
                  py={5}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flex: 1
                  }}
                >
                  <CircularProgress />
                </Box>
              )}
            </Scrollbar>
          </TableContainer>
        </Card>
        {!loading && !searchLoading && pagesCount > 1 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 10,
              alignItems: 'center'
            }}
          >
            <Pagination
              count={pagesCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
              page={page}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}
